import React from 'react';

import { SmartTaxDeliveryModal } from './SmartTaxDeliveryModal/SmartTaxDeliveryModal';
import { SmartTaxOrganizerModal } from './SmartTaxOrganizerModal/SmartTaxOrganizerModal';
import { UploadFileModal } from './UploadFileModal';
import { useWhatToDoToday } from './useWhatToDoToday';
import { WhatToDoTodayWidget } from './WhatToDoTodayWidget';
import type { PreselectedRecipient } from 'components/DesktopFileUpload/recipientAdapter';
import type { GuidedFileResumeState } from 'modules/dashboard/guidedFileIntelligence';

export interface WhatToDoTodayProps {
  autoOpenFileIntelligence?: boolean;
  onAutoOpenConsumed?: () => void;
  sampleRecipient?: PreselectedRecipient;
  resumedFileIntelligence?: GuidedFileResumeState;
}

export const WhatToDoToday: React.FC<WhatToDoTodayProps> = ({
  autoOpenFileIntelligence = false,
  onAutoOpenConsumed,
  sampleRecipient,
  resumedFileIntelligence,
}) => {
  const {
    actions,
    visibleActions,
    isLoadingPreferences,
    setActionVisibility,
    savingActionId,
    preferenceError,
    clearPreferenceError,
    isUploadModalOpen,
    closeUploadModal,
    isSmartTaxOrganizerModalOpen,
    closeSmartTaxOrganizerModal,
    completeSmartTaxOrganizer,
    isSmartTaxDeliveryModalOpen,
    closeSmartTaxDeliveryModal,
    completeSmartTaxDelivery,
  } = useWhatToDoToday({ autoOpenFileIntelligence, onAutoOpenConsumed });

  return (
    <>
      <WhatToDoTodayWidget
        actions={actions}
        visibleActions={visibleActions}
        isLoadingPreferences={isLoadingPreferences}
        onVisibilityChange={setActionVisibility}
        savingActionId={savingActionId}
        preferenceError={preferenceError}
        onClearPreferenceError={clearPreferenceError}
      />
      <UploadFileModal
        open={isUploadModalOpen}
        onClose={closeUploadModal}
        defaultRecipient={sampleRecipient}
        resumeResult={resumedFileIntelligence}
      />
      <SmartTaxOrganizerModal
        open={isSmartTaxOrganizerModalOpen}
        onClose={closeSmartTaxOrganizerModal}
        onComplete={completeSmartTaxOrganizer}
      />
      <SmartTaxDeliveryModal
        open={isSmartTaxDeliveryModalOpen}
        onClose={closeSmartTaxDeliveryModal}
        onComplete={completeSmartTaxDelivery}
      />
    </>
  );
};
